export const States = ['flyer-builder'] as const
export type StateToShow = (typeof States)[number]
